import { render } from "./LWrap.vue?vue&type=template&id=587edd47"
import script from "./LWrap.vue?vue&type=script&lang=js"
export * from "./LWrap.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__